import { Button } from "@/components/ui/button"
import { ExternalLink } from "lucide-react"

export default function Home() {
  const hubspotPortalId = import.meta.env.VITE_HS_PORTAL_ID
  const hubspotListUrl = hubspotPortalId
    && `https://app-eu1.hubspot.com/contacts/${hubspotPortalId}/objects/2-130451461/views/all/list`

  return (
    <section className="p-10 flex flex-col items-center">
      <h1 className="text-3xl font-bold mb-2 text-primary">Welkom bij Siebert & Wassink ATS</h1>
      <p className="mb-4 text-slate-800">Vacatures kan je openen via de CRM kaart in hubspot!</p>
        <Button asChild size="lg">
          <a
            href={hubspotListUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-white"
          >
            <ExternalLink className="size-4" aria-hidden />
            Open in Hubspot
          </a>
        </Button>
    </section>
  );
}
